import React, { useContext } from "react";

import Article from "../../../components/Content/Article/Article";
import ArticleSeoHead from "../../../components/Seo/ArticleSeoHead";
import AuthContext from "../../../components/Auth/AuthContext";
import ButtonLink from "../../../components/Navigation/ButtonLink";
import Error from "next/error";
import NewsletterCTA from "../../Newsletter/NewsletterCTA";
import environment from "../../../environment";
import { getArticle } from "../../../graphql/queries";
import { makeStyles } from "@material-ui/core/styles";
import useSWR from "swr";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles(() => ({
  editButton: {
    backgroundColor: "yellow",
    position: "fixed",
    zIndex: 1000,
  },
}));

const Page = (props) => {
  const { id, prefetchedArticle } = props;
  const { t } = useTranslation("common");
  const {
    auth: { isAdmin },
  } = useContext(AuthContext);
  const classes = useStyles();

  const fetchOptions = environment.features.prerenderArticles
    ? {
        fallbackData: prefetchedArticle,
      }
    : {};

  const { data, isValidating } = useSWR([getArticle, JSON.stringify({ id })], fetchOptions);

  let article = prefetchedArticle;

  if (data && data.getArticle) {
    article = data.getArticle;
  }

  if (!article) {
    return null;
  }

  if (!article && !isValidating) {
    if (typeof window !== "undefined") {
      return <Error statusCode={404} />;
    }
    const e = new Error();
    e.code = "ENOENT";
    throw e;
  }

  return (
    <React.Fragment>
      <ArticleSeoHead article={article} />
      <NewsletterCTA
        layout={article.category == "tests" ? "tests" : "general"}
        page={`article-read-${article.category}`}
      />
      {isAdmin && (
        <ButtonLink className={classes.editButton} href="/blog/edit/[id]" as={`/blog/edit/${article.id}`}>
          {t("articleEdit")}
        </ButtonLink>
      )}
      {article && <Article article={article} />}
    </React.Fragment>
  );
};

export default Page;
